import { Modal } from "react-bootstrap";

export default function ModalPDF({stateShow, title, src}: {stateShow: Array<any>, title?: string, src: string}){
    return(
        <Modal show={stateShow[0]} onHide={() => stateShow[1](false)} size="xl" centered scrollable={false} fullscreen keyboard>
            <Modal.Header className="border-bottom-0 pb-0" closeButton></Modal.Header>
            <Modal.Body className="pt-0">
                <h3 className="d-none">{title}</h3>
                <iframe src={src} width="100%" height="99%" style={{overflow: "auto"}} title="file-viewer">
                    <p>Dispositivo no compatible</p>

                </iframe>
            </Modal.Body>
        </Modal>
    )
}